var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    clipPath: "url(#clip0_818_10722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "whatsapp",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7 3.1625C16.6375 1.1 13.8875 0 11 0C4.95 0 0 4.95 0 11C0 12.925 0.550008 14.85 1.51251 16.5L0 22L5.77502 20.4875C7.42502 21.3125 9.2125 21.8625 11 21.8625C17.05 21.8625 22 16.9125 22 10.8625C22 7.975 20.7625 5.225 18.7 3.1625ZM11 20.075C9.35 20.075 7.70001 19.6625 6.32501 18.8375L6.04999 18.7L2.61249 19.6625L3.57501 16.3625L3.29999 15.95C2.33749 14.4375 1.92499 12.7875 1.92499 11.1375C1.92499 6.1875 6.05 2.0625 11 2.0625C13.475 2.0625 15.675 3.025 17.4625 4.675C19.25 6.4625 20.075 8.6625 20.075 11.1375C20.075 15.95 16.0875 20.075 11 20.075ZM15.95 13.2C15.675 13.0625 14.3 12.375 14.025 12.375C13.75 12.2375 13.6125 12.2375 13.475 12.5125C13.3375 12.7875 12.7875 13.3375 12.65 13.6125C12.5125 13.75 12.375 13.75 12.1 13.75C11.825 13.6125 11 13.3375 9.90002 12.375C9.07502 11.6875 8.52501 10.725 8.38751 10.45C8.25001 10.175 8.38752 10.0375 8.52502 9.9C8.66252 9.7625 8.8 9.625 8.9375 9.4875C9.075 9.35 9.07502 9.2125 9.21252 9.075C9.35002 8.9375 9.21252 8.8 9.21252 8.6625C9.21252 8.525 8.66251 7.15 8.38751 6.6C8.25001 6.1875 7.97502 6.1875 7.83752 6.1875C7.70002 6.1875 7.56248 6.1875 7.28748 6.1875C7.14998 6.1875 6.87498 6.1875 6.59998 6.4625C6.32498 6.7375 5.63751 7.425 5.63751 8.8C5.63751 10.175 6.59999 11.4125 6.73749 11.6875C6.87499 11.825 8.66248 14.7125 11.4125 15.8125C13.75 16.775 14.1625 16.5 14.7125 16.5C15.2625 16.5 16.3625 15.8125 16.5 15.2625C16.775 14.575 16.775 14.025 16.6375 14.025C16.5 13.3375 16.225 13.3375 15.95 13.2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_818_10722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.d1830903c6a5c60e82b417ab07fad660.svg";
export { ForwardRef as ReactComponent };